var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50369 6.00089C3.50369 5.79378 3.67159 5.62589 3.87869 5.62589H5.625V3.87956C5.625 3.67246 5.79289 3.50456 6 3.50456C6.20711 3.50456 6.375 3.67246 6.375 3.87956V5.62589H8.12133C8.32844 5.62589 8.49633 5.79378 8.49633 6.00089C8.49633 6.20799 8.32844 6.37589 8.12133 6.37589H6.375V8.1222C6.375 8.32931 6.20711 8.4972 6 8.4972C5.79289 8.4972 5.625 8.32931 5.625 8.1222V6.37589H3.87869C3.67159 6.37589 3.50369 6.20799 3.50369 6.00089Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65837 1.88526C5.20214 1.71272 6.79784 1.71272 8.34162 1.88526C9.25481 1.98733 9.99226 2.70665 10.0997 3.62513C10.2843 5.20359 10.2843 6.79819 10.0997 8.37665C9.99226 9.29513 9.25481 10.0144 8.34162 10.1165C6.79784 10.2891 5.20214 10.2891 3.65837 10.1165C2.74518 10.0144 2.00773 9.29513 1.9003 8.37665C1.71569 6.79819 1.71569 5.20359 1.9003 3.62513C2.00773 2.70665 2.74518 1.98733 3.65837 1.88526ZM8.25831 2.63062C6.7699 2.46427 5.23008 2.46427 3.74167 2.63062C3.16946 2.69458 2.71143 3.1462 2.64522 3.71225C2.46738 5.23283 2.46738 6.76895 2.64522 8.28952C2.71143 8.85558 3.16946 9.3072 3.74167 9.37115C5.23008 9.5375 6.7699 9.5375 8.25831 9.37115C8.83053 9.3072 9.28855 8.85558 9.35476 8.28952C9.5326 6.76895 9.5326 5.23283 9.35476 3.71225C9.28855 3.1462 8.83053 2.69458 8.25831 2.63062Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositType);
export default __webpack_public_path__ + "static/media/deposit-type.770c61246e9edb924cff167cb3826564.svg";
export { ForwardRef as ReactComponent };